import React from 'react';

const Card = ({ title, content, children }) => {
  return (
    <div className="card mb-3">
      <div className="card-body">
        <h5 className="card-title">{title}</h5>
        <p className="card-text">{content}</p>
        {children}
      </div>
    </div>
  );
};

export default Card;
